import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function Nav(props) {
    const {store} = props;
    const status = [];

    for (let section of store.sections.values()) {
        // store.sections.values().map((section) => {
        // const section = store.sections.get(sectionId);
        status.push(section.isVisible ? 'ON' : 'off');
    }
    return (
        <div className={'Nav'}>
            {/*<div>{scrollProgress}</div>*/}
            {status.map((status, i) => <div>{status}</div>)}
        </div>
    );
}

export default observer(Nav);
